<template>
	<div class="container">
		<div class="user-banner">
			<img :src="item.backgroundPic?item.backgroundPic:require('@/assets/user_bg.png')" />
		</div>
		<div class="content">
			<div class="user-top">
				<img class="user-avatar" :src="item.headPic?item.headPic:require('@/assets/default-avatar.png')" />
				<div class="user-num-wrap">
					<div class="user-num-list jump" @click="toCircleList">
						<span class="num-amount">{{item.circleNum}}</span>
						<span class="num-item">圈子</span>
					</div>
					<div class="user-num-list jump" @click="toFollowList">
						<span class="num-amount">{{item.followNum}}</span>
						<span class="num-item">关注</span>
					</div>
					<div class="user-num-list jump" @click="toFansList">
						<span class="num-amount">{{item.fansNum}}</span>
						<span class="num-item">粉丝</span>
					</div>
					<div class="user-num-list">
						<span class="num-amount">{{item.postNum}}</span>
						<span class="num-item">发帖数</span>
					</div>
					<div class="user-num-list">
						<span class="num-amount">{{item.beLikeNum || 0}}</span>
						<span class="num-item">获赞</span>
					</div>
				</div>
			</div>
			<div class="user-txt">
				<div class="user-txt-l">
					<div class="username-wrap">
						<div class="username">{{item.nickName}}</div>
						<div class="level" v-if="item.circleLevel">
							<img :src="item.circleLevel">
						</div>
						<!-- <div class="user-type">高级成员</div> -->
					</div>
					<div class="info-user mt-1">{{item.personSign}}</div>
					<!-- <div class="userinfo-tips">IP属地：北京</div>
					<div class="userinfo-tips">勋章16个</div> -->
				</div>
				<div class="user-txt-r" v-if="userId!=item.id">
					<div v-if="item.isFollow==1" class="follow-btn followed" @click.stop="toFollow(item)">+ 已关注</div>
					<div v-else class="follow-btn" @click.stop="toFollow(item)">+ 关注</div>
				</div>

			</div>
			<el-tabs class="tabs" v-model="activeTab" @tab-click="handleClick">
				<el-tab-pane label="帖子" name="all">
				</el-tab-pane>
				<el-tab-pane label="问答" name="2">
				</el-tab-pane>
				<el-tab-pane label="建议" name="4">
				</el-tab-pane>
				<el-tab-pane label="反馈" name="5">
				</el-tab-pane>
				<el-tab-pane label="比赛" name="6">
				</el-tab-pane>
				<el-tab-pane label="活动" name="7">
				</el-tab-pane>
				<div v-if="activeTab == 7">
					<ul class="list" v-if="postList.length >0">
						<li v-for="(item,index) in postList" @click="toDetail(item.id)" :key="index">
								<div class="list-img">
										<img :src="item.picUrl" />
								</div>
								<div class="list-title">
										<h3>{{item.name}}</h3>
								</div>
								<div class="list-tips">
										<div class="article-tags-wrap" v-if="item.talkName">
												<div class="article-tags">
														<span class="tags-icon">#</span>
														<span class="tags-name">{{item.talkName}}</span>
												</div>
										</div>
										<div class="sign" v-if="item.holdStatus!=2 && item.enrollFlag == 0" @click.stop="toSign(item)">报名</div>
										<div class="sign" v-if="item.holdStatus!=2 && item.enrollFlag == 1" @click.stop="toSign(item)">取消报名</div>
								</div>
								<div class="list-txt">
										<div class="list-txt-l">
												<span>浏览 {{item.viewNum || 0}}</span>
										</div>
										<div class="list-txt-r">
												时间：{{item.beginTime | datefmt('yyyy-MM-DD')}}～{{item.endTime | datefmt('yyyy-MM-DD')}}
										</div>
								</div>
								<div class="list-txtd">
										<div class="list-txt-l">
												<span>参与人数 {{item.enrollNum || 0}}</span>
										</div>
								</div>
						</li>
					</ul>
					<Empty v-if="!postList.length" content="该分类下无数据" />
					<Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange" />
				</div>
				<div v-else>
					<div v-if="postList.length >0">
						<div v-for="item in postList" :key="item.id">
							<!-- 问答 -->
							<questions v-if="activeTab == 2" :item="item" :type="item.categoryScene" @toGetList="getPostList"/>
							<!-- 建议类型 -->
							<suggestion v-if="activeTab == 4" :item="item" :type="item.categoryScene" @toGetList="getPostList"/>
							<!-- 反馈类型/其他普通类型 -->
							<articleCard v-if="activeTab == 5 || activeTab == 'all'" :item="item" :type="item.categoryScene" @getComment="getPostList"/>
							<!-- 比赛类型 -->
							<div v-if="activeTab == 6">
								<BannerTop :comItem="item" :isLine2=true />
							</div>
						</div>
					</div>
					<Empty v-if="!postList.length" content="该分类下无数据" />
					<Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange" />
				</div>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import articleCard from '@/components/articleCard'
import questions from '@/components/questions'
import suggestion from '@/components/suggestion'
import BannerTop from '@/components/competition/bannerTop'
import userInfoModules from '@/modules/userInfo.js'
import Pagination from '@/components/pagination'
import Empty from '@/components/empty'
import qs from 'qs'
import {
	post,
	ajaxParam
} from '@/units/request.js'
	export default {
		name: 'userIndex',
		components: {
			articleCard,
			questions,
			suggestion,
			BannerTop,
			Pagination,
			Empty
		},
		data() {
			return {
				followUserId: '',
				userId: '', //登录用户id
				item: {},
				postList: [],
				total: 0,
				pageNum: 1,
				pageSize: 10,
				auditStatus: '', //-1 全部 0未审核 1已通过 2未通过
				postType: '', //0文字  1图片 2视频
				postStatus: '', //默认是发布  0草稿  1发布
				cateList: [],
				activeTab: 'all',
				categoryId: '',
				bannerUrl: ''
			}
		},
		mixins: [
			userInfoModules
		],
		created() {
			this.userId = localStorage.getItem('userId') || ''
			this.followUserId = this.$route.query.id
			this.getUserInfo()
			this.getPostList()
			this.getPostCate()
			this.getConfigData()
		},
		methods: {
			// 跳转圈子列表
			toCircleList(){
				if ((this.item.id == this.userId) || ((this.item.id != this.userId) && this.item.beViewFlag == 1)) {
					this.$router.push({
						path: '/UserInfoCirclList?userId='+this.item.id
					})
				} else {
					this.$message.error('暂无权限')
				}
			},
			// 跳转粉丝列表
			toFansList(){
				if ((this.item.id == this.userId) || ((this.item.id != this.userId) && this.item.beViewFlag == 1)) {
					this.$router.push({
						path: '/userInfoFansList?userId='+this.item.id
					})
				} else {
					this.$message.error('暂无权限')
				}
			},
			// 跳转关注列表
			toFollowList(){
				if ((this.item.id == this.userId) || ((this.item.id != this.userId) && this.item.beViewFlag == 1)) {
					this.$router.push({
						path: '/UserInfofollowList?userId='+this.item.id
					})
				} else {
					this.$message.error('暂无权限')
				}
			},
			//获取用户主页背景图
			async getConfigData() {
				let param = {
					code: 'CIRCLE_USER_BANNER'
				}
				ajaxParam(param)
				const res = await post('v1/sysConfig/getConfigByCode', qs.stringify(param))
				if (res.data.code == 200) {
					if(res.data.entity.configValue) {
						this.bannerUrl = res.data.entity.configValue
					}
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//关注 取消关注
			async toFollow(item) {
				if (!this.userId) {
					this.$router.push({
						path: '/login'
					})
					return
				}
				let param = {
					userId: this.userId,
					followUserId: item.id,
					followFlag: item.isFollow == 1 ? 0 : 1
				}
				ajaxParam(param)
				const res = await post('v1/circle/followUser', qs.stringify(param))
				if (res.data.code == 200) {
					console.log(res.data)
					if (item.isFollow == 1) {
						this.$message.success('取消关注成功！')
					} else {
						this.$message.success('关注成功！')
					}
					item.isFollow = item.isFollow == 1 ? 0 : 1

				} else {
					this.$message.error(res.data.msg)
				}
			},
			handleClick(tab) {
				this.pageNumber = 1
				let name = tab.name
				if (tab.name == 'all') {
					this.categoryId = ''
				} else {
					this.categoryId = name
				}
				this.dataList = []
				this.pageNum = 1
				this.getPostList()
			},
			//获取发布帖子分类
			async getPostCate() {
				let param = {
					userId: this.followUserId
				}
				ajaxParam(param)
				const res = await post('v1/circle/userPostCategory', qs.stringify(param))
				if (res.data.code == 200) {
					console.log('分类分类')
					this.cateList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取发布帖子
			async getPostList() {
				if(this.activeTab == 7) {
					// 活动
					let param = {
						userId: this.followUserId,
						pageSize: this.pageSize,
						pageNum: this.pageNum,
					}
					ajaxParam(param)
					const res = await post('v1/activity/myEnrollActivity', qs.stringify(param))
					if (res.data.code == 200) {
						this.postList = res.data.list
						this.total = res.data.total
					} else {
						this.$message.error(res.data.msg)
					}
				} else if(this.activeTab == 6) {
					// 比赛
					let param = {
						userId: this.followUserId,
						pageSize: this.pageSize,
						pageNum: this.pageNum,
					}
					ajaxParam(param)
					const res = await post('v1/competition/myEnroll', qs.stringify(param))
					if (res.data.code == 200) {
						this.postList = res.data.list
						this.total = res.data.total
					} else {
						this.$message.error(res.data.msg)
					}
				} else{
					let param = {
						userId: this.followUserId,
						addUserId: this.userId,
						pageNum: this.pageNum,
						pageSize: this.pageSize,
						auditStatus: 1,
						postType: this.postType,
						postStatus: 1,
						categoryId: this.categoryId,
					}
					if (this.activeTab == 'all') {
						param.categoryId = 0
					}
					ajaxParam(param)
					const res = await post('v1/circle/userPostList', qs.stringify(param))
					if (res.data.code == 200) {
						this.postList = res.data.list
						this.total = res.data.total
					} else {
						this.$message.error(res.data.msg)
					}
				}
			},
			pageChange(e) {
				this.postList = []
				this.pageNum = e.number
				this.getPostList()
			},
			// 活动
			toDetail(id) {
				this.$router.push({
						path: '/activityDetail?id=' + id
				})
			},
			toSign(item){
				this.$confirm(`确定要${item.enrollFlag == 0 ? '报名' : '取消报名'}吗？`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
						}).then(() => {
								this.submintSing(item)
						}).catch(() => {
								this.$message({
										type: 'info',
										message: '已取消'
								});          
				});
			},
			async submintSing(item){
				let param = {
						userId: this.userId,
						activityId: item.id
				}
				ajaxParam(param)
				const res = await post('v1/activity/enrollActivity', qs.stringify(param))
				if (res.data.code == 200) {
						this.$message.success('提交成功！')
						this.getPostList()
				} else {
						this.$message.error(res.data.msg)
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 1200px;
		margin: 20px auto;
		// background: #fff;
		// border-radius: 12px;
		box-sizing: border-box;

		.user-banner {
			height: 190px;
			border-radius: 12px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.content {
			padding: 0 40px;
			background: #fff;
		}

		.user-top {
			display: flex;
			align-items: flex-end;
			padding: 0;

			.user-avatar {
				width: 90px;
				height: 90px;
				border-radius: 50%;
				border: 4px solid #fff;
				margin-top: -34px;
			}

			.user-num-wrap {
				display: flex;
				justify-content: space-around;
				flex: 1;

				.user-num-list {
					display: flex;
					flex-direction: column;
					align-items: center;
					&.jump{
						cursor: pointer;
					}
				}
			}
		}

		.user-txt {
			display: flex;
			justify-content: space-between;
			//border-bottom: 1px solid rgba(50,50,51,.14);
			// margin-bottom: 20px;
			padding-bottom: 10px;
			padding-top: 15px;

			.username-wrap {
				display: flex;
				align-items: center;

				.username {
					font-size: 16px;
					font-weight: bold;
				}

				.user-type {
					display: block;
					height: 18px;
					margin-left: 4px;
					padding: 0 4px;
					background: rgba(247, 125, 42, .18);
					border-radius: 4px;
					color: #F77D2A;
					font-size: 12px;
					line-height: 18px;
					text-align: center;
				}
			}

			.userinfo-tips {
				margin-top: 2px;
				opacity: .7;
				font-size: 12px;
			}
		}

		/deep/ .el-tabs__active-bar {
			background-color: #DD0515;
		}

		/deep/ .el-tabs__item.is-active {
			color: #DD0515;
		}

		/deep/ .el-tabs__item:hover {
			color: #DD0515;
		}

		/deep/ .el-tabs__nav-wrap::after {
			// background: none
			top: 0;
		}
		/deep/ .el-tabs__header{
			margin-bottom: 22px;
		}
	}
	
	.level{
		margin-left:5px;
		img{
			height:16px;
			margin-top: 0;
		}
	}
	.info-user {
		font-size: 14px;
		color: #979797;
	}
	.list {
		display: flex;
		flex-wrap: wrap;

		li {
				display: flex;
				flex-direction: column;
				width: 32.3333%;
				margin-right: 1.3333%;
				margin-top: 16px;
				background: #fff;
				border: 1px solid rgba(50, 50, 50, .1);
				border-radius: 4px;
				box-sizing: border-box;
				cursor: pointer;
				overflow: hidden;

				.list-img {
						img {
								width: 100%;
								height: 240px;
								max-width: 380px;
								max-height: 214px;
						}
				}

				.list-title {
						margin-top: 12px;
						margin-bottom: 4px;
						padding: 0 17px;
						line-height: 24px;
						font-size: 16px;
						font-weight: bold;
						letter-spacing: .86px;
						-webkit-line-clamp: 1;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						overflow: hidden;
				}

				.list-tips {
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding: 5px 17px 0;

						.article-tags-wrap {
								display: flex;
								cursor: pointer;
						}

						.article-tags {
								display: flex;
								border: 1px solid var(--color-border);
								margin-right: 15px;
								padding: 3px 5px;
								border-radius: 14px;

								.tags-icon {
										width: 18px;
										height: 18px;
										margin-right: 4px;
										background: #DD0515;
										border-radius: 14px;
										color: #fff;
										line-height: 18px;
										text-align: center;
								}

								.tags-name {
										font-size: 12px;
										color: var(--color-text);
								}
						}

						span {
								color: var(--color-text-a);
						}

						a,.sign {
								width: 78px;
								height: 28px;
								background: #DD0515;
								border-radius: 4px;
								text-align: center;
								line-height: 28px;
								color: #fff;
						}

						.end-btn {
								background: #F3F4F7;
								color: var(--color-text-opacity);
						}

						.begin-btn {
								background: rgba(207, 23, 29, 0.1);
								border: 1px solid #DD0515;
								color: var(--color-text-a);
						}
				}

				.list-txt {
						display: flex;
						justify-content: space-between;
						margin-top: 10px;
						padding: 0 17px;
						font-size: 12px;
						color: var(--color-text-opacity);
						line-height: 22px;
				}
				.list-txtd {
						padding: 0 17px;
						font-size: 12px;
						margin-bottom: 10px;
						color: var(--color-text-opacity);
						line-height: 22px;
				}
		}

		li:nth-of-type(3n) {
				margin-right: 0;
		}

		li:hover {
				position: relative;
				box-shadow: 0 2px 8px 0 rgba(34, 123, 255, .36);
				border-radius: 6px;
				z-index: 1
		}
}
.competition {
	border: 1px solid #e2e2e2;
}
</style>
